// extracted by mini-css-extract-plugin
export default {"skills":"skills_skills__GU+Mg","techIcon":"skills_techIcon__HWdD4","techIcons":"skills_techIcons__iGG63"};